import React, { useEffect, useRef, useState } from "react";
import "./groupWiseQuery.css";
import QueryHeader from "../Query Header/QueryHeader";
import QueryList from "../Query_List/QueryList";
import axios from "../../../../axios";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import QueryExpand from "../Query_List/QueryExpand";
import { toast } from "react-toastify";
import { X } from "lucide-react";
import assets from "../../../../assets/assets";
import { IoIosArrowBack } from "react-icons/io";

// import { io } from "socket.io-client";

// let socket;

const GroupWiseQuery = () => {
  const [click, setClick] = useState(false);
  const [query, setQuery] = useState([]);
  const [editQueryData, setEditQueryData] = useState({});
  const [isGettingData, setIsGettingData] = useState(false);
  const [isPreventApiCall, setIsPreventApiCall] = useState(false);
  const [isProgress, setIsProgress] = useState(false);
  const lastPageRef = useRef(false);
  const loadingRef = useRef(false);
  const [filter, setFilter] = useState({
    date: null,
    tag: null,
    name: null,
    status: null,
    sortBy: -1,
    time: null,
    limit: 20,
    page: 1,
    searchClick: false,
  });
  const [data, setData] = useState([]);
  const [delQuery, setDelQuery] = useState(false);
  const [group, setGroup] = useState({});
  //Added this state by Kuldeep
  const { state } = useLocation();
  const [click1, setClick1] = useState(false);
  const [clickPost, setClickPost] = useState(false);
  const [initialQuery, setInititalQuery] = useState([]);
  const [expandQuery, setExpandQuery] = useState(false);
  const [index, setIndex] = useState();
  const [dataFinal, setDataFinal] = useState();
  // useEffect(() => {
  //   socket = io("http://localhost:3001");
  // }, []);

  const navigate = useNavigate();

  useEffect(() => {
    let getGroup = async () => {
      setIsGettingData(true);
      try {
        let response = await axios.get(
          `/api/v1/group/getById/${state.groupId}?isFullFledged=true`
        );
        if (response) {
          setGroup(response.data.data);
          setIsGettingData(false);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsGettingData(false);
      }
    };
    getGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  const handleRefresh = () => {
    setIsProgress(true);
    lastPageRef.current = false;
    loadingRef.current = false;

    setQuery([]);
    setFilter((prev) => ({
      ...prev,
      page: 1,
      searchClick: !prev.searchClick,
    }));
  };

  const handelInfiniteScroll = async () => {
    try {
      if (
        document.getElementById("inner-scrollable-div").clientHeight +
        document.getElementById("inner-scrollable-div").scrollTop +
        1.9 >=
        document.getElementById("inner-scrollable-div").scrollHeight
      ) {
        if (!loadingRef.current && !lastPageRef.current) {
          setFilter((prevState) => ({
            ...prevState,
            page: prevState.page + 1,
          }));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const element = document.getElementById("inner-scrollable-div");

    if (element) {
      element.addEventListener("scroll", handelInfiniteScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener("scroll", handelInfiniteScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getInitalaQuery = async () => {
    try {
      let response = await axios.get(
        `/api/v1/query/getForTeacher/groupId/${state.groupId}?_page=1&_limit=1&sortBy=${filter.sortBy}`
      );
      setInititalQuery(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getInitalaQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function formatDate(inputDate) {
    console.log(inputDate);
    const dateObject = new Date(inputDate);
    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObject.getDate().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    // setSelectedDate(formattedDate) ;
    return formattedDate;
  }

  const { date, tag, name, status, sortBy, time, limit, page, searchClick } =
    filter;

  const getAllQuery = async () => {
    setIsGettingData(true);
    // const { page, limit, sortBy, status, name, tag, date, time } = filter;
    try {
      let response = await axios.get(
        `/api/v1/query/getForTeacher/groupId/${state.groupId}?_page=${page}&_limit=${limit}&sortBy=${sortBy}` +
        `${status && status !== "all" ? `&status=${status}` : ``}` +
        `${name
          ? `&name=${name}`
          : tag
            ? `&tags=${tag}`
            : date
              ? `&date=${formatDate(date)}`
              : ``
        }` +
        `${time && time !== null ? `&time=${time}` : ``}`
      );

      const totalFetchedQuery = query.length + response.data.data.length;
      const loadedQuery = Math.min(
        totalFetchedQuery,
        Number(response.data.total_query_count)
      );

      if (
        response.data.data.length == 0 ||
        loadedQuery === response.data.total_query_count
      ) {
        lastPageRef.current = true;
      }
      // setInProgress(false);
      if (page === 1) {
        setQuery(response.data.data);
      } else {
        setQuery((prev) => [...prev, ...response.data.data]);
      }
      setIsGettingData(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsGettingData(false);
    }
  };

  useEffect(() => {
    getAllQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delQuery, searchClick, status, page, sortBy, time]);

  // useEffect(() => {
  //   socket.on("new query", (newQuery) => {
  //     setQuery((prev) => [...prev, ...newQuery]);
  //   });
  // });
  // const refetchLogic = async () => {
  //   setFilter({
  //     ...filter,
  //     page: 1
  //   });
  //   setQuery([])
  //   getQuery()
  // }

  useEffect(() => {
    const fetchData = () => {
      function generateItems(query) {
        const sortedMessages = query.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );

        const messagesByDay = {};
        sortedMessages.forEach((message) => {
          const date = new Date(message.created_at);
          const day = new Date(
            Date.UTC(
              date.getUTCFullYear(),
              date.getUTCMonth(),
              date.getUTCDate()
            )
          );
          if (messagesByDay[day]) {
            messagesByDay[day].push(message);
          } else {
            messagesByDay[day] = [message];
          }
        });
        return messagesByDay;
      }
      try {
        const result = generateItems(query);
        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [filter.name, query]);

  return (
    <div className="w-100 h-100">
      {!expandQuery && (
        <div className="d-flex gap-2 align-items-center">
          <IoIosArrowBack
            onClick={() => navigate("/queryGroups")}
            style={{ cursor: "pointer" }}
          />

          <div
            className="d-flex flex-column gap-1"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/queryGroups")}
          >
            <span className="head_manual">Student Query</span>
            <span className="fw-small  text-muted" style={{ fontSize: "10px" }}>
              Dashboard / Engagement / Student Query
            </span>
          </div>
        </div>
      )}

      <div
        className="d-flex flex-column  p-4 mt-2"
        style={{ backgroundColor: "white" }}
      >
        {!expandQuery && (
          <QueryHeader
            editQueryData={editQueryData}
            setEditQueryData={setEditQueryData}
            setFilter={setFilter}
            filter={filter}
            change={setClick}
            query={query}
            setQuery={setQuery}
            groupData={group}
            click={click1}
            setClick={setClick1}
            initialQuery={initialQuery}
            setIsGettingData={setIsGettingData}
            setIsPreventApiCall={setIsPreventApiCall}
            handleRefresh={handleRefresh}
          />
        )}
        {!expandQuery && (
          <div>
            <div
              className="orange-scrollBar main_box"
              id="inner-scrollable-div"
            >
              {!initialQuery.length > 0 ? (
                <div
                  style={{ marginTop: "14%" }}
                  className="d-flex flex-column justify-content-center align-items-center"
                >
                  <span className="no_query">
                    No queries yet. Be the first one to create a query.
                  </span>
                  <button
                    style={{ width: "15%" }}
                    className="mt-2 btn btn-light creaeQueryBtn"
                    onClick={() => {
                      setClick1(true);
                      setClick(true);
                      setClickPost(true);
                    }}
                  >
                    Create Query
                  </button>
                </div>
              ) : // isGettingData ? (<img className="ongoing_loader" style={{ marginLeft: "650px" }} src="/gif/LoaderDot.gif" alt="loader" />) :
                query?.length > 0 ? (
                  <>
                    {Object.keys(data).map((day, index) => (
                      <div key={index}>
                        {data[day].map((item, index) => (
                          <QueryList
                            change={setClick}
                            setEditQueryData={setEditQueryData}
                            setDelQuery={setDelQuery}
                            key={index}
                            setQuery={setQuery}
                            queries={item}
                            setExpandQuery={setExpandQuery}
                            setDataFinal={setDataFinal}
                            setIndex={setIndex}
                            groupData={group}
                            handleRefresh={handleRefresh}
                          />
                        ))}
                      </div>
                    ))}
                  </>
                ) : isGettingData ? (
                  <img
                    className="ongoing_loader"
                    src="/gif/LoaderDot.gif"
                    alt="loader"
                  />
                ) : (
                  <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                    <span className="d-flex flex-column justify-content-center align-items-center">
                      No Query Found!!
                    </span>
                  </div>
                )}
            </div>
          </div>
        )}
        {expandQuery && (
          <QueryExpand
            change={setClick}
            setEditQueryData={setEditQueryData}
            setQuery={setQuery}
            queries={dataFinal}
            setDelQuery={setDelQuery}
            setExpandQuery={setExpandQuery}
            setDataFinal={setDataFinal}
            groupData={group}
            handleRefresh={handleRefresh}
          />
        )}
      </div>
    </div>
  );
};

export default GroupWiseQuery;
